<section class="container">
<div class="mt-5" >
  <h1>
    <span class="strok-text">{{ data.title.split(' ')[0] }}-</span>{{data.title.split(' ')[1]}}
  </h1>
  <div>
    <img
      width="100%"
      [src]="data.imgsrc"
      [alt]="data.imgalt"
    />
  </div>
  <h5 class="mt-2">
    {{data.content}}
  </h5>
</div>
</section>